import api from '../utils/httpClient';
import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';


export const getSystemDevices = createAsyncThunk(
	'systemDevices/getSystemDevices',
	async (csUserId:string) => {
	  //console.log('getSystemDevices params');
	  const response = await api.get(
	  `device/${csUserId}/system_devices`, // `device/system_devices`,
	  {
		  timeout: 30000,
	  });
	  console.log('getSystemDevices response', response.data);
	  return response.data;
	}
);

export const getDeviceInfo = createAsyncThunk(
	'systemDevices/getDeviceInfo',
	async (deviceId: string) => {
	  //console.log('getDeviceInfo params');
	  const response = await api.get(
	    `device/${deviceId}/info`,
	    {
		    timeout: 30000,
	    }
    );
	  console.log('getDeviceInfo response', response.data);
	  return response.data;
	}
);

const initialState: {
  status: string;
  error: string;
  data: any;
} = {
  status: '',
  error: '',
  data: {},
};

const devicesSlice = createSlice({
  name: 'systemDevices',
  initialState: initialState,
  reducers: {
      csDevicesSliceClean(state) {
        //console.log('csDevicesSliceClean', action);
        state.data.loading = false;
        state.data.complete = false;
        state.data.error = '';
        state.data.detailsLoading = false;
        state.data.detailsComplete = false;
    },
  },
  extraReducers: (builder) => {
      //getSystemDevices
      builder.addCase(getSystemDevices.pending, (state) => {
        state.data.loading = true;
        state.data.complete = false;
        state.data.error = '';
      });
      builder.addCase(getSystemDevices.fulfilled, (state, action) => {
        state.data.loading = false;
        state.data.complete = true;
        state.data = Object.assign(state.data, action.payload);
      });
      builder.addCase(getSystemDevices.rejected, (state, action) => {
        state.data.loading = false;
        state.data.complete = false;
        state.data = Object.assign(state.data, action.payload);
        state.data.error = action.error ? action.error.message! : '';
      });

      //getDeviceInfo
      builder.addCase(getDeviceInfo.pending, (state) => {
          state.data.detailsLoading = true;
          state.data.detailsComplete = false;
          state.data.error = '';
      });
      builder.addCase(getDeviceInfo.fulfilled, (state, action) => {
          state.data.detailsLoading = false;
          state.data.detailsComplete = true;
          state.data = Object.assign(state.data, action.payload);
      });
      builder.addCase(getDeviceInfo.rejected, (state, action) => {
          state.data.detailsLoading = false;
          state.data.detailsComplete = false;
          state.data = Object.assign(state.data, action.payload);
          state.data.error = action.error ? action.error.message! : '';
      });
  }
});

export const { csDevicesSliceClean } = devicesSlice.actions;
export default devicesSlice;
